import { deployPathPrefix } from './deployPaths'

export function siteAppRoutePath(segment: string): string {
  const trimmed = segment.trim()
  const prefix = deployPathPrefix()
  if (prefix.length === 0) return `/${trimmed}`
  return `${prefix}/${trimmed}`.replace(/\/+/g, '/')
}
